import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Register_img from "../../assests/login01.png.png";
import PatnerRegisterImg from "../../assests/patnerregister.png";
import LogoDashboard from "../../assests/logo-dashboard.png";
import style from "./Register.module.css";
import { RxEyeOpen, RxEyeClosed } from "react-icons/rx";
import {
  Alert,
  Snackbar,
} from "@mui/material";
import { baseurl, getPostAuthRedirectPath } from "../Url";
import { IoCheckmarkCircle } from "react-icons/io5";
import { auth, googleProvider } from "../Firebase";
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { FcGoogle } from "react-icons/fc";
import { encryptJsonData } from "../EncryptionUtils";
import { ROLE_004, ROLE_005 } from "../../constants/roles";



function Register() {
  const navigate = useNavigate();
  const isPatnerRoute = typeof window !== "undefined" && window.location.pathname.startsWith("/patner");

  useEffect(() => {
    if (!import.meta.env.VITE_FIREBASE_API_KEY) {
      console.error("VITE_FIREBASE_API_KEY is missing in .env file!");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("authPortal", isPatnerRoute ? "patner" : "member");
  }, [isPatnerRoute]);

  // Capture referral data (skill_id + ref_code) from URL when landing on Register
  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const skillId = params.get("skill_id");
    const refCode = params.get("ref_code");

    if (!skillId && !refCode) return;

    if (refCode) {
      localStorage.setItem("duno_referral_code", refCode);
    }
    if (skillId) {
      localStorage.setItem("duno_referral_asset_id", skillId);
      localStorage.setItem("duno_referral_asset_category", "SKILL");
    }
  }, []);


  const [agreed, setAgreed] = useState(false)
  const [userName, setUserName] = useState("")
  const [email, setEmail] = useState("")
  const [validationErrors, setValidationErrors] = useState({});
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [touched, setTouched] = useState({ userName: false, email: false,});


  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = re.test(email);
    setIsEmailValid(isValid);
    return isValid;
  };

  const validateForm = () => {
  const errors = {};

  if (!userName.trim()) {
    errors.userName = "Name is required";
  }

  if (!email.trim()) {
    errors.email = "Email is required";
  } else if (!validateEmail(email)) {
    errors.email = "Enter a valid email address";
  }

  if (!agreed) {
    errors.agreed = "You must accept terms";
  }

  setValidationErrors(errors);
  return Object.keys(errors).length === 0;
};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      userSignUp()
    }
  };

  async function userSignUp() {
    const body = {
      Username: email,
      Email: email,
      Name: userName,
      role:"Intern"
    };

    await fetch(`${baseurl}/account/send-signup-otp`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === "success") {
          navigate("/email/verification", {
            state: {
              Email: email,
              Username: email,
              Name: userName,
              role:"Intern",
              mode: "signup"
            }
          })

        } else if (data.status === "error" || data.status === "failed") {
          alert(data.message || "Signup failed");
        }
      });
  }

  async function googleSignup() {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const googleIdToken = credential.idToken;
      const referralCode =
        (typeof window !== "undefined" && window.localStorage.getItem("duno_referral_code")) ||
        (typeof window !== "undefined" && window.sessionStorage.getItem("duno_referral_code"));
      const referralAssetCategory =
        (typeof window !== "undefined" && window.localStorage.getItem("duno_referral_asset_category")) ||
        (typeof window !== "undefined" && window.sessionStorage.getItem("duno_referral_asset_category"));
      const referralAssetId =
        (typeof window !== "undefined" && window.localStorage.getItem("duno_referral_asset_id")) ||
        (typeof window !== "undefined" && window.sessionStorage.getItem("duno_referral_asset_id"));

      const body = {
        credential: googleIdToken,
        name: result.user.displayName,
        email: result.user.email,
        role:"Intern",
        ...(referralCode && { referral_code: referralCode }),
        ...(referralAssetCategory && { referral_asset_category: referralAssetCategory }),
        ...(referralAssetId && { referral_asset_id: referralAssetId })
      };
      const newdata = JSON.stringify(body);
      const encryptstring = encryptJsonData(newdata);
      await fetch(`${baseurl}/account/login/googleverification`, {
        method: "POST",
        body: JSON.stringify({
          keys: encryptstring,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("Google Signup Response:", data);
          if (data.status === "success") {
            localStorage.setItem(
              "access-token",
              JSON.stringify(data.data.access_token)
            );
            localStorage.setItem("ClubID", data.data.club_id);
            localStorage.setItem("ORGID", data.data.org_id);
            localStorage.setItem("USERID", data.data.user_id);
            localStorage.setItem("mentor", data.data.is_mentor);
            localStorage.setItem("roleId", isPatnerRoute ? ROLE_005 : ROLE_004);
            localStorage.setItem("role", isPatnerRoute ? "patner" : "intern");
            localStorage.setItem("username", result.user.displayName || data.data.username);
            navigate(getPostAuthRedirectPath(data.data.user_id));
          } else {
            alert(data.message || "Google Signup Failed");
          }
        })
        .catch((err) => {
          console.error("Google Signup Error:", err);
          alert("An error occurred during Google Signup");
        });
    } catch (error) {
      console.error("Firebase Google Signup Error:", error);
      alert("Google Signup Failed");
    }
  }


  return (
    <div className={style.Container}>
      {isPatnerRoute && (
        <header className={style.patnerHeader}>
          <img src={LogoDashboard} alt="Duno Club Logo" className={style.patnerHeaderLogo} />
        </header>
      )}
      <div className={`${style.RegisterBody} ${isPatnerRoute ? style.patnerRegisterBody : ""}`}>
        <div className={`${style.registerBodyLeft} ${isPatnerRoute ? style.patnerRegisterBodyLeft : ""}`}>
          <div className={style.formBox}>
            <div className={style.welcomeTxt}>
              <p className={style.welcomeHead}>
                Welcome to <span>Duno Club</span>
              </p>
              <p className={style.welcomeSubHead}>
                Start your journey!
              </p>
            </div>

            <div className={style.formContainer}>
              <div className={style.formFeilds}>

                <div className={style.formGroup}>
                  <div className={`${style.Username} ${validationErrors.userName ? style.error : ''}`} >
                    <input
                      type="text"
                      placeholder="Name"
                      name="name"
                      value={userName}
                      onBlur={() => setTouched({ ...touched, userName: true })}
                      onChange={(e) => {
                        setUserName(e.target.value)
                        setValidationErrors((prevErrors) => ({ ...prevErrors, userName: '' }));
                      }}
                    />
                  </div>

                </div>
                {touched.userName && validationErrors.userName && (
  <p className={style.errorText}>{validationErrors.userName}</p>
)}

                <div className={style.formGroup}>
                  <div className={`${style.emailBox} ${validationErrors.email ? style.error : ''}`} >

                    <input
                      type="email"
                      placeholder="E-mail"
                      name="email"
                      value={email}
                      onBlur={() => setTouched({ ...touched, email: true })}
                      onChange={(e) => {
                        setEmail(e.target.value)
                        validateEmail(e.target.value);
                        setValidationErrors((prevErrors) => ({ ...prevErrors, email: '' }));
                      }}
                    />
                    {touched.email && isEmailValid && (
                      <span className={style.checkMark}>
                        <IoCheckmarkCircle />
                      </span>
                    )}
                  </div>

                </div>
                {validationErrors.email && (
                    <p style={{ color: "red", fontSize: "14px", padding:"0.5rem" }}>
                      Enter a valid email address
                    </p>
                  )}

              </div>
              <div className={style.declare}>
                <label className={style.customCheckbox}>
                  <input
                    type="checkbox"
                    name="remember"
                    checked={agreed}
                    onChange={(e) => setAgreed(e.target.checked)}
                  />
                  <span className={style.checkmark}></span>
                  &nbsp;
                  <p>
                    I am aged 18 or over and agree to the{" "}
                    <span>Terms and conditions</span> and{" "}
                    <span>Privacy policy</span>{" "}
                  </p>
                </label>
              </div>

              <button disabled={!agreed} onClick={(e) => handleSubmit(e)}>Sign Up</button>

              <div className={style.OR}>OR</div>

              <div className={style.Google}>
                <button type="button" className={style.googleBtn} onClick={googleSignup}>
                  <FcGoogle size={28} style={{ backgroundColor: "white", borderRadius: "50%" }} />
                  Sign up with Google
                </button>
              </div>

              <div className={style.signUp}>
                <p>Already have an account?</p>
                <p>
                  <span onClick={() => {
                    navigate(isPatnerRoute ? "/patner/login" : "/login")
                  }}>Login</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {isPatnerRoute ? (
          <div className={`${style.registerBodyRight} ${style.patnerRegisterBodyRight}`}>
            <div className={`${style.groupImg} ${style.patnerGroupImg}`}>
              <img src={PatnerRegisterImg} alt="Partner register" />
            </div>
          </div>
        ) : (
          <div className={style.registerBodyRight}>
            <div className={style.groupImg}>
              <img src={Register_img} alt="register" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Register;
